import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Button, Card } from '../../components/primitives/index.js'
import ProductVisual from '../../components/ProductVisual.jsx'
import { customerApi } from '../../lib/customerApi.js'
import { api } from '../../lib/api.js'
import { useCart } from '../../context/CartContext.jsx'
import './AccountWishlist.css'

export default function AccountWishlist() {
  const [entries, setEntries] = useState([])
  const [products, setProducts] = useState([])
  const { addItem } = useCart()

  useEffect(() => {
    Promise.all([customerApi.getWishlist(), api.getProducts()]).then(([wl, all]) => {
      setEntries(wl?.items ?? [])
      setProducts(all)
    })
  }, [])

  async function handleRemove(id) {
    await customerApi.removeFromWishlist(id)
    setEntries((prev) => prev.filter((e) => e.id !== id))
  }

  function handleAdd(product, variantId) {
    const variant = product.variants.find((v) => v.id === variantId) ?? product.variants[0]
    addItem(product, variant, 1)
  }

  if (entries.length === 0) {
    return <Card className="account-wishlist__empty">Nothing saved yet — browse the catalog and tap "Wishlist" on a product.</Card>
  }

  return (
    <div className="account-wishlist__grid">
      <AnimatePresence>
        {entries.map((entry) => {
          const product = products.find((p) => p.id === entry.productId)
          if (!product) return null
          return (
            <motion.div key={entry.id} layout initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.9 }}>
              <Card className="account-wishlist__item">
                <div className={`account-wishlist__item-visual${product.imageKey ? ' account-wishlist__item-visual--photo' : ''}`}>
                  <ProductVisual product={product} />
                </div>
                <div className="account-wishlist__item-info">
                  <h3>{product.name}</h3>
                  <p>{product.subtitle}</p>
                </div>
                <div className="account-wishlist__item-actions">
                  <Button size="sm" variant="primary" onClick={() => handleAdd(product, entry.variantId)}>
                    Add to cart
                  </Button>
                  <Button size="sm" variant="ghost" onClick={() => handleRemove(entry.id)}>
                    Remove
                  </Button>
                </div>
              </Card>
            </motion.div>
          )
        })}
      </AnimatePresence>
    </div>
  )
}
